import { useState } from 'react';
import { CROSS_SELL_FIELDS } from '../constants';

const { CROSS_SELL_RADIUS } = CROSS_SELL_FIELDS;

const getPropertyDataRows = (properties, crossSellRadius) => {
  return properties.filter((property) => property.distance <= crossSellRadius);
};

const getExcludedPropertiesMap = (nearbyPropertiesExcludedProperties) => {
  return nearbyPropertiesExcludedProperties.reduce(
    (excludedPropertiesMap, propertyId) => {
      excludedPropertiesMap[propertyId] = true;
      return excludedPropertiesMap;
    },
    {},
  );
};

export const useCrossSell = ({
  excludedProperties,
  properties,
  radius,
  updateCrossSell,
}) => {
  const [propertyDataRows, setPropertyDataRows] = useState(
    getPropertyDataRows(properties, radius),
  );
  const [excludedPropertiesMap, setExcludedPropertiesMap] = useState(
    getExcludedPropertiesMap(excludedProperties),
  );

  const handleUpdateCrossSellRadius = (updatedRadius) => {
    setPropertyDataRows(getPropertyDataRows(properties, updatedRadius));

    updateCrossSell({ [CROSS_SELL_RADIUS]: updatedRadius });
  };

  const handleUpdateCrossSell = (field) => (value) => {
    updateCrossSell({ [field]: value });
  };

  return {
    excludedPropertiesMap,
    handleUpdateCrossSell,
    handleUpdateCrossSellRadius,
    propertyDataRows,
    setExcludedPropertiesMap,
  };
};
